<template>
  <div class="kcjs-content">
    <img src="../../../assets/image/kjqg/kcjsgm/kcjsgm-banner.png" class="kcjs-banner">
    <div class="kcjs-main">
      <div class="kcjs-menu">
        <div class="menu-item" v-for="item,ind in menuList" :key="ind" :class="{active:item.title == activeObj.title }">
          <div class="menu-text" @click="setMenu(item)">{{item.title}}</div>
        </div>
      </div>
      <div class="kcjs-right">
        <commonList :activeObj="activeObj" v-if="activeObj.title == '科学家精神' || activeObj.title == '科创先锋' || activeObj.title == '科学人生'"></commonList>
        <dggxList :activeObj="activeObj" v-if="activeObj.title == '大国功勋'"></dggxList>
        <kjxjList :activeObj="activeObj" v-if="activeObj.title == '科技小匠'"></kjxjList>
      </div>
    </div>
    <div class="spin-con" v-if="loading">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
      </a-spin>
    </div>
  </div>
</template>

<script>
import services from "../../../assets/js/services.js";
import { mapActions } from "vuex";
import utils from "../../../assets/js/utils.js";
import commonList from "./components/common-list"
import dggxList from "./components/dggx-list.vue"
import kjxjList from "./components/kjxj-list.vue"
export default {
  components: {
    commonList,
    dggxList,
    kjxjList
  },
  data() {
    return {
      school_code: localStorage.getItem("schoolCode"),
      specialId: services.KJQG_SPECIAL_ID,
      kjhzList: [],
      page: 1,
      total: 0,
      pageSize: 16,
      pageNum: 0,
      activeObj: {
        title: "科学家精神",
      },
      loading: false,
      menuList: [
        {
          title: "科学家精神",
        },
        {
          title: "大国功勋",
        },
        {
          title: "科创先锋",
          children: [
            {
              title: "科技领军人物"
            },
            {
              title: "青年科技说"
            },
            {
              title: "巾帼女科学家"
            },
            {
              title: "最美科技工作者"
            },
          ],
          defaultInd: 0
        },
        {
          title: "科技小匠",
        },
        {
          title: "科学人生",
        },]
    }
  },
  async created() {
    let res = await this.getAppsLoginUserInfo();
    this.isChrome = utils.bowerUserAgent();
    if (res.code != "0000") {
      this.$message.info("请先登录！");
      this.$router.push({ path: `/${this.school_code}/kjqg/kjqgIndex` });
    }
    if (this.$route.query.ind > -1) {
      let activeCate = this.menuList[this.$route.query.ind]
      if (activeCate.children && this.$route.query.cateInd > -1) {
        activeCate.defaultInd = this.$route.query.cateInd
      }
      this.activeObj = activeCate
    }

  },
  methods: {
    ...mapActions(["goAppsDetailsBeforeLogin", "getAppsLoginUserInfo"]),
    setMenu(item) {
      this.activeObj = item
    }
  }
}
</script>

<style lang="less" scoped>
body {
  // overflow-x: hidden;
}
.kcjs-content {
  padding: calc(3.64vw + 42px) 0 50px;
  background-image: url("../../../assets/image/kjqg/common/common-bg.jpg");
  background-size: 100% auto;
  .kcjs-banner {
    width: 100%;
    margin-bottom: 36px;
  }
  .kcjs-main {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .kcjs-menu {
      width: 208px;
      height: 388px;
      background-image: url("../../../assets/image/kjqg/kcjsgm/menu-bg.png");
      background-size: cover;
      text-align: center;
      padding-top: 32px;
      position: sticky;
      top: 200px;
      .menu-item {
        width: 182px;
        height: 38px;
        position: relative;
        margin: 0 0 20px auto;
        .menu-text {
          width: 100%;
          height: 38px;
          color: #bbffff;
          line-height: 38px;
          font-weight: bold;
          cursor: pointer;
          position: absolute;
          background-image: url("../../../assets/image/kjqg/kcjsgm/menu-item.png");
          background-size: cover;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          transition: all 0.3s;
        }
        &:hover {
          .menu-text {
            background-image: url("../../../assets/image/kjqg/kcjsgm/menu-item-hover.png");
            color: #1672e5;
            height: 50px;
            line-height: 50px;
          }
        }
        &.active {
          .menu-text {
            background-image: url("../../../assets/image/kjqg/kcjsgm/menu-item-hover.png");
            color: #1672e5;
            height: 50px;
            line-height: 50px;
          }
        }
      }
    }
    .kcjs-right {
      //   flex: 1;
      width: 928px;
    }
  }
  .spin-con {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    top: 0;
    z-index: 999;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>